export const DEFAULT_MINIMUM_LOADING_MS = 0;

export default function useMinimumLoading(active) {
  return Boolean(active);
}
